export const getError = state => state.editGroup.get('error')
export const getIsSubmitting = state => state.editGroup.get('isSubmitting')
